import content from './content/accounts.json';

export const accountsMock = {
  name: 'accounts',
  layoutType: 1,
  areasList: [
    {
      id: 'accounts-main',
      componentName: 'Comp:AccountsPage',
      content: JSON.stringify(content)
    }
  ]
};
